// ============================================================
// Helper « marge » côté frontend (garde-fou de rentabilité)
// ============================================================
// Doit refléter backend/src/utils/marge.js.
//   marge = prix - cout
//   taux  = marge / cout * 100   (marge SUR LE COÛT)
//   niveaux : inconnu | perte | faible | ok
//
// Un prix à 0 (ou vide) = « non défini » → niveau 'inconnu' (on n'affiche
// pas d'alerte). Un coût (PAM) à 0 = jamais approvisionné → 'inconnu'.
// ============================================================

export const SEUIL_DEFAUT_PCT = 10;

export function evaluerMarge(prix, cout, seuilPct = SEUIL_DEFAUT_PCT) {
  const p = Number(prix);
  const c = Number(cout);
  const seuil = Number.isFinite(Number(seuilPct)) ? Number(seuilPct) : SEUIL_DEFAUT_PCT;

  if (!Number.isFinite(c) || c <= 0) return { niveau: 'inconnu', cout: 0, marge: null, taux: null };
  if (!Number.isFinite(p) || p <= 0) return { niveau: 'inconnu', cout: c, marge: null, taux: null };

  const marge = p - c;
  const taux = (marge / c) * 100;
  let niveau;
  // Prix ≤ coût d'achat → « perte » (inclut le cas prix = coût : marge nulle).
  if (p <= c) niveau = 'perte';
  else if (taux < seuil) niveau = 'faible';
  else niveau = 'ok';
  return { niveau, cout: c, marge, taux };
}

// Classes Tailwind (texte + fond) par niveau, pour la pastille.
export function classesMarge(niveau) {
  switch (niveau) {
    case 'perte':  return 'text-red-300 bg-red-900/30 border-red-700/50';
    case 'faible': return 'text-amber-300 bg-amber-900/30 border-amber-700/50';
    case 'ok':     return 'text-emerald-300 bg-emerald-900/30 border-emerald-700/50';
    default:       return 'text-gray-400 bg-gray-800/60 border-gray-700/50';
  }
}

// Est-ce une vente/un prix à perte ? (déclenche la confirmation obligatoire)
export function estPerte(prix, cout) {
  const p = Number(prix), c = Number(cout);
  // Inclut l'égalité : un prix de vente égal au coût d'achat est signalé aussi.
  return Number.isFinite(p) && p > 0 && Number.isFinite(c) && c > 0 && p <= c;
}
